
<div class="container">
  <div class="row loginContent justify-content-center align-items-center">
    <div class="col-lg-4 text-center">
      <img runat="server" [src]="logoUrl" style="max-width: 350px; max-height: 350px;" />
    </div>


    <!-- #region div login -->
    <div class="col-lg-8" *ngIf="isLogin">
      <div class="form-group w-75 mx-auto" *ngIf="showInputDB">
        <input type="text" class="form-control" [(ngModel)]="clientDB" (change)="checkInput()" placeholder="Nom de la base de données" />
        <span *ngIf="inputChk.dbalert !== ''" class="validator">{{inputChk.dbalert}}</span>
      </div>

      <div class="form-group w-75 mx-auto">
        <span class="q-text-s">Utilisateur:</span>
        <input type="text" class="form-control" [(ngModel)]="user" (change)="checkInput()" placeholder="Utilisateur" />
        <span *ngIf="inputChk.useralert !== ''" class="validator">{{inputChk.useralert}}</span>
      </div>

      <div class="w-75 mx-auto align">
        <div>
          <span class="q-text-s">Mot de passe:</span>
          <queoval-virtual-num-pad #numPad [enableNumpad]="enableNumpad"></queoval-virtual-num-pad>
        </div>
        <span *ngIf="inputChk.pswdalert !== ''" class="validator">{{inputChk.pswdalert}}</span>
      </div>

      <div class="form-group w-75 mx-auto mt-4">
        <button class="btn btn-secondary q-button2 float-right ml-2 ispointer" title="Je veux accéder à l'assistance." (click)="redirectTo('ASSISTANCE')">
          <i class="fa fa-cog" aria-hidden="true" style="color:#fff;"></i>
        </button>
        <button class="btn btn-danger q-button2 float-right ml-2 ispointer" title="J'ai oubli&eacute; mon mot de passe" (click)="redirectTo('RECOVERY')">
          <i class="fa fa-lock" aria-hidden="true"></i>
        </button>
        <button  *ngIf="!enableNumpad" class="btn btn-secondary q-button2 float-right ml-2 ispointer" title="Connexion via Google" (click)="logGoogle()">
          <i class="fab fa-google" aria-hidden="true" style="color:#fff;"></i>
        </button>
        <button  *ngIf="!enableNumpad" class="btn btn-light q-button2 float-right ml-2 ispointer" title="Connexion via Microsoft" (click)="logMS()">
          <i class="fab fa-windows" aria-hidden="true" style="color:#222;"></i>
        </button>
        <button class="btn btn-info btn-md connBtn ispointer" (click)="logUser()" [disabled]="isLoading">
          <i *ngIf="isLoading" class="fas fa-spin fa-spinner fa-pulse q-c-main mr-1"></i>Connexion
        </button> 
      </div>
    </div>
    <!-- #endregion -->
    <!-- #region div recovery -->
    <div class="col-lg-8" *ngIf="!isLogin">
      <p class="text-center text-white">Mot de passe oubli&eacute; ? Entrez votre identifiant de connexion.</p>
      <div class="form-group w-75 mx-auto">
        <label class="text-white">Nom du client</label>
        <input type="text" class="form-control" [(ngModel)]="recoverydb" />
        <span *ngIf="recoverydbalert !== ''" class="dbalert">{{recoverydbalert}}</span>
      </div>

      <div class="form-group w-75 mx-auto">
        <label class="text-white">Nom de l'utilisateur</label>
        <input type="text" class="form-control" [(ngModel)]="recoveryuser" />
        <span *ngIf="recoveryuseralert !== ''" class="validator">{{recoveryuseralert}}</span>
      </div>

      <div class="form-group w-75 mx-auto">
        <label class="text-white">E-mail</label>
        <input type="text" class="form-control" [(ngModel)]="recoverymail" />
        <span *ngIf="recoverymailalert !== ''" class="validator">{{recoverymailalert}}</span>
      </div>
      <div class="form-group w-75 mx-auto mt-4">
        <button class="btn btn-info btn-md connBtn" (click)="sendPswdRequest()">Demander</button>
      </div>
      <p class="retourLabel" (click)="backLogin()">Retour &agrave; la page de connexion</p>
    </div>

    <!-- #endregion -->


  </div>

</div>

